/* ============================================================
   EFX — glyph guard (product pages)
   ============================================================
   GENERATED by efx_font_coverage.py --website from
   website/efx-glyph-guard.template.js. Edit the template, not
   the generated asset.

   A customer's custom text or back name may only use
   characters its chosen font can actually print. Order
   38632-02-01 asked for "John 3:16" in Shock; Shock cannot
   print a colon, so the jersey printed a box. The field now
   says so and Add to Cart waits until the text or the font
   changes. (The preview acknowledgement is a DPO option.)

   Fonts come from the same table the production automation
   uses (font files read with fontTools), so the website and
   the print agree on what each font can do.
   ============================================================ */
/* build: 2026-10-10c */
(function () {
  "use strict";
  if (window.__efxGlyphGuard) return;
  window.__efxGlyphGuard = true;

  // { "Font label": "characters it cannot print" }
  var GAPS = {
  "Alisha Script": "\u00aa\u00ac\u00af\u00b2\u00b3\u00b5\u00b7\u00b9\u00ba\u00bc\u00bd\u00be\u00c6\u00d0\u00de\u00f0\u00fe",
  "American Captain": "\u00d7\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff",
  "Amsterdam": "\u00a2\u00a4\u00a5\u00a6\u00a7\u00aa\u00ab\u00ac\u00af\u00b0\u00b1\u00b2\u00b3\u00b5\u00b6\u00b9\u00ba\u00bb\u00bc\u00bd\u00be",
  "Athletic": "!\"#$%&()*+/;<=>?@[\\]^_`{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Athletic 2": "!\"#$%&'()*+,-/:;<=>?@[\\]^_`{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Axis": "\u00a4",
  "Blacksword": "^~\u00a6\u00aa\u00ac\u00af\u00b0\u00b1\u00b2\u00b3\u00b7\u00b9\u00ba\u00bc\u00bd\u00be\u2013\u2014",
  "Brush 2": "0123456789",
  "Brush Script": "\u00b7",
  "College": "#$%()*+/<=>@[\\]^_`{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Copper Bold": "\u00b7",
  "Donuts": "\u00aa\u00ac\u00af\u00b1\u00b2\u00b3\u00b9\u00ba\u00bc\u00bd\u00be",
  "Dripping Marker": "\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Great Day": "!\"#$%&'(*+,-./:;<=>?@^{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Infinite Script": "\u00a6\u00aa\u00ac\u00af\u00b0\u00b1\u00b2\u00b3\u00b7\u00b9\u00ba\u00bc\u00bd\u00be\u2013\u2014",
  "Light Up": "\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b1\u00b2\u00b3\u00b6\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u2018\u2019\u201c\u201d\u2026\u2122",
  "Love Script": "\u00a6\u00aa\u00ac\u00af\u00b0\u00b2\u00b3\u00b6\u00b7\u00b9\u00ba\u2013\u2014\u2026",
  "New Athletic": "!\"#%&'()*+,-/:;<=>?@[\\]^_`|~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "RS Script": "#$123456789\u00a3\u00a4\u00a5\u20ac",
  "Shaker": "\u00aa\u00b1\u00b5\u00ba",
  "Shock": "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Signature Script": "\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c6\u00d0\u00d7\u00de\u00e6\u00f0\u00f7\u00fe\u2013\u2014\u2026\u2022\u20ac\u2122",
  "Silver": "<>[]{}\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b1\u00b2\u00b3\u00b5\u00b6\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00d0\u00d8\u00dd\u00de\u00df\u00f0\u00f8\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u2122",
  "Slim": "!\"#$%&'()*+-/:;<=>?@[\\]^_`{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122",
  "a dripping marker": "\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122"
};
  // Characters judged at all. Anything outside this set (emoji, symbols
  // from other scripts) is refused in every font.
  var CHECKED = "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u2018\u2019\u201c\u201d\u2013\u2014\u2026\u2022\u20ac\u2122";

  function visible(el) {
    if (!el) return false;
    if (el.closest(".ihidden")) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function titleOf(field) {
    var l = field.querySelector("label") || field.firstElementChild;
    return ((l && l.textContent) || "").replace(/\s+/g, " ").trim();
  }

  function isFontSelect(el) {
    if (!el || el.tagName !== "SELECT") return false;
    for (var i = 0; i < el.options.length; i++) {
      var v = (el.options[i].value || el.options[i].text || "").trim();
      if (Object.prototype.hasOwnProperty.call(GAPS, v)) return true;
      if (Object.prototype.hasOwnProperty.call(GAPS, el.options[i].text.trim())) return true;
    }
    return false;
  }

  function selectedFont(sel) {
    if (!sel || sel.selectedIndex < 0) return "";
    var o = sel.options[sel.selectedIndex];
    return ((o && (o.text || o.value)) || "").replace(/\s*\+\$[\d.]+\s*$/, "").trim();
  }

  // Each text box with the font picker it belongs to. Custom Text boxes take
  // the Font Style picker straight after them; the back name lines take the
  // one before them (the form asks for the font first).
  function pairs() {
    var fields = Array.prototype.slice.call(document.querySelectorAll("div.field"));
    var list = [];
    fields.forEach(function (f) {
      var c = f.querySelector("textarea, select, input[type=text]");
      if (!c) return;
      list.push({ field: f, control: c, title: titleOf(f) });
    });
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      if (it.control.tagName === "SELECT") continue;
      var t = it.title.toLowerCase();
      var font = null, j;
      if (/custom text/.test(t)) {
        for (j = i + 1; j < list.length && j <= i + 2; j++) {
          if (isFontSelect(list[j].control)) { font = list[j].control; break; }
        }
      } else if (/(first|second) line/.test(t)) {
        for (j = i - 1; j >= 0 && j >= i - 6; j--) {
          if (isFontSelect(list[j].control)) { font = list[j].control; break; }
        }
      }
      if (font) out.push({ text: it.control, font: font, field: it.field, title: it.title });
    }
    return out;
  }

  function problem(text, fontLabel) {
    if (!text) return "";
    var gaps = GAPS[fontLabel];
    var bad = [];
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (/\s/.test(ch)) continue;
      var refused = CHECKED.indexOf(ch) < 0 || (gaps && gaps.indexOf(ch) >= 0);
      if (refused && bad.indexOf(ch) < 0) bad.push(ch);
    }
    if (!bad.length) return "";
    var shown = bad.map(function (c) { return "“" + c + "”"; }).join(" ");
    return (fontLabel || "This font") + " can’t print " + shown +
      ". Remove " + (bad.length > 1 ? "them" : "it") + " or choose a different font.";
  }

  function message(field, text) {
    var m = field.querySelector(".efx-glyph-error");
    if (!text) { if (m) m.remove(); return; }
    if (!m) {
      m = document.createElement("div");
      m.className = "efx-glyph-error";
      m.setAttribute("role", "alert");
      m.style.cssText = "color:#c62828;font-size:13px;margin-top:6px;line-height:1.35;";
      field.appendChild(m);
    }
    m.textContent = text;
  }

  // Checks every visible text box; returns the first field with a problem.
  // quiet: report only, leave the page's messages alone.
  function checkAll(quiet) {
    var first = null;
    pairs().forEach(function (p) {
      // Only the text box has to be showing: the theme hides the Font Style
      // dropdown behind its own font pills, but the dropdown still holds the
      // customer's choice.
      var err = visible(p.text)
        ? problem((p.text.value || "").trim(), selectedFont(p.font)) : "";
      if (!quiet) {
        message(p.field, err);
        p.text.style.outline = err ? "2px solid #c62828" : "";
      }
      if (err && !first) first = p.field;
    });
    return first;
  }

  // ---- blocking Add to Cart ---------------------------------------------
  // Add to Cart, and the express checkout buttons beside it ("Buy with
  // Shop", Buy it now), which would otherwise skip both checks.
  var CART_BUTTONS = "#itoris_dynamicoptions_add_to_cart, button[name=add], .add_to_cart, .btn-cart, .efx-express-cover, " +
    "shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button, " +
    "[data-shopify=payment-button]";

  function isAddToCart(el) {
    var b = el && el.closest && el.closest(CART_BUTTONS);
    return b && b.closest("form[action*='/cart/add'], .product, main") ? b : null;
  }

  function stop(e, target) {
    e.preventDefault();
    e.stopImmediatePropagation();
    // After the page has finished with the click (it scrolls on its own), and
    // instant: something on the product page cancels smooth scrolling.
    if (target && target.scrollIntoView) {
      setTimeout(function () { target.scrollIntoView({ block: "center" }); }, 80);
    }
  }

  // On WINDOW, capturing: another script on the product page stops the click
  // at window level, so a document listener never hears Add to Cart.
  window.addEventListener("click", function (e) {
    if (!isAddToCart(e.target)) return;
    var bad = checkAll();
    if (bad) return stop(e, bad);
    if (e.target.classList && e.target.classList.contains("efx-express-cover")) {
      // Everything is fine now; lift the cover so the next click goes through.
      e.preventDefault();
      syncExpress();
    }
  }, true);

  // The page swallows the click on the express-checkout cover after the
  // press, so the cover answers the press itself.
  window.addEventListener("pointerdown", function (e) {
    if (!(e.target.classList && e.target.classList.contains("efx-express-cover"))) return;
    var bad = checkAll();
    if (bad) return stop(e, bad);
    syncExpress();
  }, true);

  window.addEventListener("submit", function (e) {
    if (!e.target || !/\/cart\/add/.test(e.target.getAttribute("action") || "")) return;
    var bad = checkAll();
    if (bad) stop(e, bad);
  }, true);

  // Express checkout ("Buy with Shop") draws its button inside a frame, so
  // its clicks never reach this page. While any text is unprintable, a
  // transparent cover sits over it; pressing the cover shows the same message
  // Add to Cart would.
  function syncExpress() {
    var ok = !checkAll(true);
    var areas = document.querySelectorAll(".shopify-payment-button, shopify-accelerated-checkout");
    for (var i = 0; i < areas.length; i++) {
      var area = areas[i];
      if (area.parentElement && area.parentElement.closest(".shopify-payment-button")) continue;
      var cover = area.querySelector(":scope > .efx-express-cover");
      if (ok) { if (cover) cover.remove(); continue; }
      if (cover) continue;
      if (getComputedStyle(area).position === "static") area.style.position = "relative";
      cover = document.createElement("div");
      cover.className = "efx-express-cover";
      cover.title = "Fix the highlighted text first";
      cover.style.cssText = "position:absolute;inset:0;z-index:5;cursor:pointer;background:transparent;";
      // Its clicks are handled by the window listener below (CART_BUTTONS):
      // another script on the page stops clicks before they reach it.
      area.appendChild(cover);
    }
  }

  // ---- preview acknowledgement (a DPO checkbox option) -----------------
  // Randy added "I understand the website preview may differ..." to DPO as a
  // required checkbox (2026-10-10). DPO draws it as a bare checkbox; every
  // other option is a card drawn by efx-dpo-customizations.js. This redraws
  // it with those same card classes (efx-time-*), so it looks identical, and
  // keeps DPO's real checkbox underneath: the card just ticks it, so DPO's
  // own required check still decides. Only the checkbox and its text are
  // hidden, not their container, so DPO's "required" message still shows.
  var ACK_RE = /website preview may differ/i;

  function enhanceAck() {
    var boxes = document.querySelectorAll("div.field.choice input[type=checkbox]");
    for (var i = 0; i < boxes.length; i++) {
      var input = boxes[i];
      var choice = input.closest("div.field.choice");
      if (!choice || choice.getAttribute("data-efx-ack")) continue;
      var lab = choice.querySelector("label");
      var text = ((lab && lab.textContent) || "").replace(/\s+/g, " ").trim();
      if (!ACK_RE.test(text)) continue;
      choice.setAttribute("data-efx-ack", "1");
      buildAckCard(input, lab, choice, text);
    }
  }

  function important(el, prop, val) { el.style.setProperty(prop, val, "important"); }

  function buildAckCard(input, lab, choice, text) {
    var stack = document.createElement("div");
    stack.className = "efx-time-stack efx-ack-stack";
    important(stack, "width", "100%");
    var card = document.createElement("div");
    card.className = "efx-time-card";
    card.setAttribute("role", "checkbox");
    card.tabIndex = 0;
    important(card, "grid-template-columns", "20px minmax(0, 1fr)");
    important(card, "width", "100%");
    important(card, "align-items", "center");
    var mark = document.createElement("div");
    mark.className = "efx-time-radio";
    important(mark, "border-radius", "3px");           // square: it's a checkbox
    var dot = document.createElement("div");
    dot.className = "efx-time-radio-dot";
    important(dot, "border-radius", "1px");
    mark.appendChild(dot);
    var info = document.createElement("div");
    info.className = "efx-time-info";
    var lead = text.match(/^\s*I acknowledge\b[:,]?\s*/i);
    // Always one sentence: "I ACKNOWLEDGE" in bold capitals, then the DPO text
    // (Randy, 2026-10-10: the DPO text now starts "the website preview ...").
    // If the DPO text itself begins "I acknowledge", it is not repeated.
    var rest = lead ? text.slice(lead[0].length) : text;
    var detail = document.createElement("div");
    detail.className = "efx-time-days";
    important(detail, "white-space", "normal");
    important(detail, "font-size", "13px");
    important(detail, "line-height", "1.45");
    important(detail, "color", "#222");
    var strong = document.createElement("strong");
    strong.textContent = "I acknowledge";
    important(strong, "color", "#000");
    important(strong, "font-weight", "700");
    important(strong, "text-transform", "uppercase");
    important(strong, "letter-spacing", "0.7px");
    detail.appendChild(strong);
    detail.appendChild(document.createTextNode(" " + rest));
    info.appendChild(detail);
    card.appendChild(mark);
    card.appendChild(info);
    stack.appendChild(card);

    function sync() {
      var on = !!input.checked;
      card.classList.toggle("selected", on);
      dot.style.display = on ? "" : "none";
      card.setAttribute("aria-checked", on ? "true" : "false");
    }
    card.addEventListener("click", function () { input.click(); sync(); });
    card.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") { e.preventDefault(); input.click(); sync(); }
    });
    input.addEventListener("change", sync);

    input.style.display = "none";
    if (lab) lab.style.display = "none";
    // DPO's 5px margin on the choice would set the card in from the others.
    important(choice, "margin", "0");
    // DPO's "I acknowledge:" heading above the option: the card says it now.
    var field = choice.parentElement && choice.parentElement.closest("div.field");
    var heading = field && field.querySelector(":scope > label");
    if (heading) important(heading, "display", "none");
    choice.insertBefore(stack, choice.firstChild);
    sync();
  }

  // Live feedback while typing or changing fonts.
  document.addEventListener("input", function (e) {
    if (e.target && e.target.tagName === "TEXTAREA") { checkAll(); syncExpress(); }
  }, true);
  document.addEventListener("change", function (e) {
    if (e.target && e.target.tagName === "SELECT") {
      setTimeout(function () { checkAll(); syncExpress(); }, 0);
    }
  }, true);

  // DPO builds its form after load and shows fields as options change.
  enhanceAck();
  setInterval(function () { enhanceAck(); syncExpress(); }, 1000);
})();
